import { html } from "lit-element";
import { render } from "lit-html";
import { StatefulModule } from "./ModuleMetadata";

export class DrawSVGTextBaseModule extends StatefulModule {
	Activate() {
		this.canvas.defaultCursor = "crosshair";
		this.__onDraw = this.onDraw.bind(this); //save reference to bound function to be able to deactivate
		this.canvas.on("mouse:down", this.__onDraw);
		return this;
	}

	Deactivate() {
		this.canvas.setCursor(this.canvas.defaultCursor);
		this.canvas.off("mouse:down", this.__onDraw);
	}

	onDraw(o) {
		this.Draw(this.canvas.getPointer(o.e), this.text)
		this.fireOnDraw();
	}

	Draw(pointer, text = "") {
		let tempDiv = document.createElement("div");
		render(this.icon(text), tempDiv);
		const svgString = tempDiv.innerHTML;
		tempDiv.remove();
		tempDiv = undefined;

		const canvas = this.canvas;

		fabric.loadSVGFromString(svgString, (objects, options) => {
			const obj = fabric.util.groupSVGElements(objects, options);

			if (obj.width > obj.height) {
				obj.scaleToHeight(50);
			} else {
				obj.scaleToWidth(50);
			}

			obj
				.set({ left: pointer.x, top: pointer.y })
				.setCoords();

			obj.selectable = false;

			this.addMetadata(obj, { text: text });

			canvas.add(obj);
			canvas.renderAll();
		});
	}

	render() {
		return html`
			<style>
				 :host {
					padding: 5px;
					cursor: pointer;
				}

				svg {
					max-height: 100%;
					max-width: 100%;
					cursor: pointer;
				}
				</style>
			<div>${this.icon(this.text)}</div>`;
	}

	RenderSettings(obj, closeFunc) {
		const currentSettings = obj.moduleState;
		let tmpText = currentSettings.text;

		const applyFunc = () => {
			this.applyNewSettings(obj, tmpText);
			closeFunc();
		};

		return html`
            <style>
                .title {
                    font-size: x-large;    
                    font-weight: bold;
                    margin-bottom: 20px;
                }
                .button-box {
                    display: flex;
                    margin-top: 20px;
                }
            </style>
            <div class="title">${this._getSettingsHeader()}</div>
            <div> 
				<text-box type="text" label="Text" 
					@change="${e => (tmpText = e.currentTarget.value)}"
					.value="${tmpText}"></text-box>
            </div>
            <div class="button-box">
                <mwc-button @click="${closeFunc}" label="Close"></mwc-button>
                <mwc-button @click="${applyFunc}" label="Apply"></mwc-button>
            </div>`;
	}

	applyNewSettings(obj, text) {

		const currentSettings = obj.moduleState;
		if (currentSettings.text == text) return;

		this.Draw({ x: obj.left, y: obj.top }, text)
		this.canvas.remove(obj);
		let newObj = this.canvas._objects[this.canvas._objects.length - 1]
		let oldTextLength = obj._objects.find(object => {
			return (object.hasOwnProperty('text'))
		})
		let newTextLength = newObj._objects.find(object => {
			return (object.hasOwnProperty('text'))
		})
		newObj.set({
			angle: obj.angle,
			selectable: true,
			scaleX: obj.scaleX,
			scaleY: obj.scaleY,
			width: obj.width + newTextLength.width - oldTextLength.width
		})
		this.canvas.setActiveObject(newObj);
		this.canvas.getActiveObject().setCoords()
		this.canvas.renderAll();
		this.canvas.trigger("object:modified", { newObj });
	}

	static get properties() {
		return { text: { type: String } };
	}

	constructor(canvas, text) {
		super();
		this.canvas = canvas;
		this.text = text;
		this.setAttribute("shape-base", "shape-base");
	}
}
